
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Widget": function() {
return Promise.all(/*  | __federation_expose_Widget */ [__webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("__federation_expose_Widget")]).then(function() { return function() { return __webpack_require__(21885); }; });
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };